module.exports = __webpack_public_path__ + "img/bgc20.fdcc2b83.png";